export const DATE_FORMAT = "ddd MMM D, YYYY";

export const DATE_FORMAT_CONCISE = "ddd MMM D";

export const DATE_TIME_FORMAT = "MM/DD/YY h:mm A";

export const DURATION_FORMAT = "H:mm";

export const TIME_FORMAT = "h:mm A";

export const WEEK_FORMAT_SHORT = "ddd";

export const STANDARD_DATE_FORMAT = "MM/DD/YYYY";

export const SECTION_TITLE_DATE_FORMAT = "DD MMMM YYYY";
